const empty = {};
/** Trim given props object so it contain only className field. */
export default function clsProps(props: Record<any, any>) {
    const cls = props["className"] as string;
    return cls ? { className: cls } : empty;
}
